import React, {Component} from 'react';
import '../CSS/App.css';
import {connect} from 'react-redux';
import {Systems, Incidents, Status} from "../Redux/ContentfulContentGrabber";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class MainHeaderStatusComponent extends Component {

    //Gathers redux contentful data before the component mounts
    componentWillMount() {
        this.props.fetchSystemData();
        this.props.fetchIncidentsData();
        this.props.fetchStatusData();
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.systems) && !Array.isArray(this.props.incidents) && !Array.isArray(this.props.status);
    }

    //This finds the largest incident the system is experiencing, i.e. if there is an Outage and a Maintenance
    // the main header status would show red for an outage
    setMaxStatusLevel(maxStatusLevel) {
        for (let i = 0; i < this.props.systems.items.length; i++) {
            let statusNumber = this.setStatusNumber(i);
            if (statusNumber > maxStatusLevel) {
                maxStatusLevel = statusNumber;
            }
        }
        return maxStatusLevel;
    }

    //The status number is determined by what is returned from Helpful, if there is an Outage the number is 3,
    // if there is maintenance the number is 2 and if there is an alert the status is 1
    setStatusNumber(i) {
        let statusNumber = 0;
        for (let k = 0; k < this.props.incidents.items.length; k++) {
            if (this.props.systems.items[i].fields.name === this.props.incidents.items[k].fields.system.fields.name) {
                if (this.props.incidents.items[k].fields.resolved === false) {
                    if (this.props.incidents.items[k].fields.status.fields.statusName === "Currently not available") {
                        if (statusNumber < 3) {
                            statusNumber = 3;
                        }
                    } else if (this.props.incidents.items[k].fields.status.fields.statusName === "Maintenance") {
                        if (statusNumber < 2) {
                            statusNumber = 2;
                        }
                    } else if (this.props.incidents.items[k].fields.status.fields.statusName === "Alert") {
                        if (statusNumber < 1) {
                            statusNumber = 1;
                        }
                    }
                }
            }
        }
        return statusNumber;
    }

    render() {
        if (this.isContentfulContentAvailableYet()) {
            let maxStatusLevel = 0;
            maxStatusLevel = this.setMaxStatusLevel(maxStatusLevel);
            let status = [];
            let titleText = "";
            let subTitleText = [];

            //This sets the header image and text to what is the largest incident all services are experiencing
            //No Issues
            if (maxStatusLevel === 0) {
                status.push(<img draggable="false" src={this.props.status.items[3].fields.statusIcon.fields.file.url}
                                 width="120px"
                                 alt="No Issues"/>);
                titleText = this.props.status.items[3].fields.statusHeaderTitle;
                subTitleText.push(<h3
                    className="alertSubtitle">{this.props.status.items[3].fields.statusHeaderSubtitle}</h3>);
            }
            // Maintenance
            else if (maxStatusLevel === 2) {
                status.push(<img draggable="false" src={this.props.status.items[1].fields.statusIcon.fields.file.url}
                                 width="120px" alt="Maintenance"/>);
                titleText = this.props.status.items[1].fields.statusHeaderTitle;
                subTitleText.push(<h3
                    className="alertSubtitle">{this.props.status.items[1].fields.statusHeaderSubtitle}</h3>);
            }
            // Alert
            else if (maxStatusLevel === 1) {
                status.push(<img draggable="false" src={this.props.status.items[2].fields.statusIcon.fields.file.url}
                                 width="120px" alt="Alert"/>);
                titleText = this.props.status.items[2].fields.statusHeaderTitle;
                subTitleText.push(<h3
                    className="alertSubtitle">{this.props.status.items[2].fields.statusHeaderSubtitle}</h3>);
                //Outage
            } else {
                status.push(<img draggable="false" src={this.props.status.items[0].fields.statusIcon.fields.file.url}
                                 width="120px" alt="Outage"/>);
                titleText = this.props.status.items[0].fields.statusHeaderTitle;
                subTitleText.push(<h3
                    className="alertSubtitle">{this.props.status.items[0].fields.statusHeaderSubtitle}</h3>);
            }

            return (
                //React CSS Transition Group causes the component to fade in
                <ReactCSSTransitionGroup
                    transitionName="example"
                    transitionAppear={true}
                    transitionAppearTimeout={50000}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div id="current_status" className="section align_center justify_content_center">
                        {status}
                        <h1 className="fontBoldLarge headerTitle">{titleText}</h1>
                        <h2 className={"noMargin"}>{subTitleText}</h2>
                    </div>
                </ReactCSSTransitionGroup>
            )
        }
        //Returns null if contentful content is not available yet
        return (null);
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        systems: state.systems,
        status: state.status,
        incidents: state.incidents,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchSystemData: () => dispatch(Systems()),
        fetchStatusData: () => dispatch(Status()),
        fetchIncidentsData: () => dispatch(Incidents())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainHeaderStatusComponent);



// WEBPACK FOOTER //
// ./src/Components/MainHeaderStatusComponent.js